import lazysizes from '../libs/lazysizes.min'


function ResponsiveImages() {
    if ( ! window.HTMLPictureElement ) {
        import(/* webpackChunkName: "picturefill" */ '../libs/picturefill.min.js' );
    }
}

export default ResponsiveImages;